// @ts-nocheck
import { LitElement, css, html } from "lit"
import { unsafeHTML } from "lit/directives/unsafe-html.js"
import { when } from "lit/directives/when.js"
const { apiFetch } = window.wp
import * as noUiSlider from "nouislider"
import styles from "nouislider/dist/nouislider.css"

const SVG_PLUS = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M6 12H18" stroke="#4B883C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12 18V6" stroke="#4B883C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

const SVG_MINUS = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M6 12H18" stroke="#4B883C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6.00488 11.9951L18.0049 11.9951" stroke="#4B883C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

export class Filters extends LitElement {
	static properties = {
		totalMatching: { type: Number },
		open: { type: Boolean },
		brands: { type: Array },
		terms: { type: Array },
		productAttributes: { type: Array },
		selected_location: { type: Object },
		selected_brand: { type: Object },
		selected_attributes: { type: Object },
		price_min: { type: Number },
		price_max: { type: Number },
		price_current_min: { type: Number },
		price_current_max: { type: Number },
		nonce: { type: String },
		locations: { type: Array },
		openGroups: { type: Object },
		openSelect: { type: String },
	}

	createRenderRoot() {
		return this
	}

	constructor() {
		super()
		this.open = false
		this.totalMatching = 0
		this.locations = []
		this.brands = []
		this.productAttributes = []
		this.selected_brand = null
		this.selected_location = {}
		this.selected_attributes = {}
		this.price_min = 0
		this.price_max = 0
		this.price_current_min = 0
		this.price_current_max = 0
		this.nonce = ""
		this.openGroups = {}
		this.openSelect = ""
	}

	connectedCallback() {
		super.connectedCallback()

		apiFetch({
			path: "/wc/store/products/attributes",
			method: "GET",
			headers: {
				"X-WP-Nonce": this.nonce,
			},
		}).then(attributes => {
			this.productAttributes = attributes
			this.productAttributes.forEach((element, index) => {
				apiFetch({
					path: `/wc/store/products/attributes/${element.id}/terms`,
					method: "GET",
					headers: {
						"X-WP-Nonce": this.nonce,
					},
				}).then(terms => {
					this.productAttributes[index].terms = terms
				})
			})
		})
		apiFetch({
			path: "/wc/store/v1/products/brands?orderby=name&order=asc",
			method: "GET",
			headers: {
				"X-WP-Nonce": this.nonce,
			},
		}).then(brands => {
			// woocommerce does not order correctly, so we sort here
			brands.sort((a, b) => {
				if (a.name < b.name) {
					return -1
				}
				if (a.name > b.name) {
					return 1
				}
				return 0
			})
			this.brands = brands
		})
		apiFetch({
			path: "/wc/store/products/locations",
			method: "GET",
			headers: {
				"X-WP-Nonce": this.nonce,
			},
		}).then(locations => {
			console.log(locations)
			this.locations = locations
		})

		this.addEventListener("price-change", e => {
			this.price_current_min = e.detail.from
			this.price_current_max = e.detail.to
		})

		this.addEventListener("result-changed", e => {
			console.log(e)
			if (e.detail && e.detail.total) {
				this.totalMatching = e.detail.total
			}
		})
	}

	_toggleOpen(e) {
		this.open = !this.open
	}

	_toggleSelect(key) {
		this.openSelect = this.openSelect === key ? null : key
	}

	_selectBrand(brand) {
		this.selected_brand = brand
	}

	_toggleAccordion(title) {
		this.openGroups = {
			...this.openGroups,
			[title]: !this.openGroups[title],
		}

		if (title === "Pris" && this.openGroups[title] && !this.priceSlider) {
			const slider = this.querySelector("#price-slider")
			noUiSlider.create(slider, {
				start: [0, 10000],
				connect: true,
				range: { min: 0, max: 10000 },
				step: 500,
				tooltips: [false, false],
				format: {
					to: v => Math.round(v),
					from: v => Number(v),
				},
			})

			slider.noUiSlider.on("update", values => {
				this.dispatchEvent(
					new CustomEvent("price-change", {
						detail: { from: values[0], to: values[1] },
					}),
				)
			})
			this.priceSlider = slider.noUiSlider
		}
	}

	_isOpen(title) {
		return !!this.openGroups[title]
	}

	_toggleAttribute(attrId, term) {
		let termId = term.slug
		if (!this.selected_attributes[attrId]) {
			this.selected_attributes[attrId] = []
		}
		this.selected_attributes[attrId] = termId

		// trigger reactivity
		this.selected_attributes = { ...this.selected_attributes }

		console.log(this.selected_attributes)
	}

	_removeAttribute(attrId) {
		if (this.selected_attributes[attrId]) {
			delete this.selected_attributes[attrId]
			this.selected_attributes = { ...this.selected_attributes }
		}
	}

	_toggleLocation(e) {
		const locationId = parseInt(e.target.value)
		if (e.target.checked) {
			this.selected_locations = [...this.selected_locations, locationId]
		} else {
			this.selected_locations = this.selected_locations.filter(
				id => id !== locationId,
			)
		}
	}

	_applyFilters() {
		/**
		 * Edit URL with params and dispatch event
		 */
		const url = new URL(window.location.href)
		const params = url.searchParams

		// Update params with selected filters
		if (this.selected_brand?.id) {
			params.set("brand", this.selected_brand.id.toString())
		} else {
			params.delete("brand")
		}
		if (this.selected_location?.id) {
			params.set("location", this.selected_location.id.toString())
		} else {
			params.delete("location")
		}

		;[...params.keys()]
			.filter(k => k.startsWith("attributes["))
			.forEach(k => params.delete(k))

		if (
			this.selected_attributes &&
			Object.keys(this.selected_attributes).length > 0
		) {
			const attrs = Object.keys(this.selected_attributes).map((key, index) => ({
				attribute: key,
				slug: this.selected_attributes[key],
			}))

			attrs.forEach((a, i) => {
				params.set(`attributes[${i}][attribute]`, a.attribute)
				params.set(`attributes[${i}][slug]`, a.slug)
			})
		}

		if (this.price_current_min) {
			params.set("price_min", this.price_current_min.toString())
		} else {
			params.delete("price_min")
		}
		if (this.price_current_max) {
			params.set("price_max", this.price_current_max.toString())
		} else {
			params.delete("price_max")
		}

		// Update the URL without reloading the page
		window.history.replaceState({}, "", `${url.pathname}?${params}`)

		const event = new CustomEvent("filters-changed", {
			detail: {
				brands: this.selected_brands,
				attributes: this.selected_attributes,
				price_min: this.price_current_min,
				price_max: this.price_current_max,
			},
			bubbles: true,
			composed: true,
		})
		this.dispatchEvent(event)
		this.open = false
	}

	render() {
		return html`
			<aside>
				<button @click=${this._toggleOpen}>
					Filter
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="17"
						height="13"
						viewBox="0 0 17 13"
						fill="none">
						<line
							x1="0.5"
							y1="10.5"
							x2="2.5"
							y2="10.5"
							stroke="#1C1E1D"
							stroke-linecap="round" />
						<line
							x1="6.5"
							y1="10.5"
							x2="16.5"
							y2="10.5"
							stroke="#1C1E1D"
							stroke-linecap="round" />
						<line
							x1="0.5"
							y1="6.5"
							x2="10.5"
							y2="6.5"
							stroke="#1C1E1D"
							stroke-linecap="round" />
						<line
							x1="14.5"
							y1="6.5"
							x2="16.5"
							y2="6.5"
							stroke="#1C1E1D"
							stroke-linecap="round" />
						<line
							x1="0.5"
							y1="2.5"
							x2="2.5"
							y2="2.5"
							stroke="#1C1E1D"
							stroke-linecap="round" />
						<line
							x1="6.5"
							y1="2.5"
							x2="16.5"
							y2="2.5"
							stroke="#1C1E1D"
							stroke-linecap="round" />
						<circle cx="4.5" cy="10.5" r="2" stroke="#1C1E1D" />
						<circle cx="4.5" cy="2.5" r="2" stroke="#1C1E1D" />
						<circle cx="12.5" cy="6.5" r="2" stroke="#1C1E1D" />
					</svg>
				</button>

				<div
					class="overlay ${this.open ? "open" : ""}"
					@click=${this._toggleOpen}></div>
				<div class="filters ${this.open ? "open" : ""}">
					<h2>
						Filtrera bland ${this.totalMatching ?? 1} produkter
						<button
							class="close"
							@click=${this._toggleOpen}
							aria-label="Stäng filter">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none">
								<rect x="0.5" y="0.5" width="23" height="23" stroke="#4B883C" />
								<path
									d="M7.75781 7.75732L16.2431 16.2426"
									stroke="#4B883C"
									stroke-width="1.5"
									stroke-linecap="round"
									stroke-linejoin="round" />
								<path
									d="M7.75691 16.2426L16.2422 7.75732"
									stroke="#4B883C"
									stroke-width="1.5"
									stroke-linecap="round"
									stroke-linejoin="round" />
							</svg>
						</button>
					</h2>
					${this.renderLocations()} ${this.renderPrice()} ${this.renderBrands()}
					${this.productAttributes.map(attr => this.renderAttribute(attr))}

					<button class="apply" @click=${() => this._applyFilters()}>
						Filtrera
					</button>
				</div>
			</aside>
		`
	}

	renderLocations() {
		return html`
			<div
				class="filter-group"
				data-title="Plats"
				?data-open=${this._isOpen("Plats")}>
				<h3 @click=${() => this._toggleAccordion("Plats")}>
					Plats
					${when(
						this._isOpen("Plats"),
						() => html`${unsafeHTML(SVG_MINUS)}`,
						() => html`${unsafeHTML(SVG_PLUS)}`,
					)}
				</h3>
				<div class="content">
					<div
						class="select ${this.openSelect === "locations" ? "open" : ""}"
						@click=${() => this._toggleSelect("locations")}
						aria-expanded=${this.openSelect === "locations" ? "true" : "false"}
						aria-controls="location-options">
						<div class="select-display">
							<span>
								${this.selected_location?.name
									? this.selected_location.name
									: "Välj plats"}
							</span>
							${this.selected_location?.name
								? html`<button
										aria-label="Ta bort filter för plats"
										@click=${() => {
											this.selected_location = {}
										}}>
										✕
									</button>`
								: html`<span>▾</span>`}
						</div>
						${this.openSelect === "locations"
							? html` <div class="select-options">
									${this.locations && this.locations.length > 0
										? this.locations.map(
												location => html`
													<div
														class="select-option ${this.selected_location
															?.id === location.id
															? "selected"
															: ""}"
														@click=${e => {
															this.selected_location = location
														}}>
														${location.name}
													</div>
												`,
											)
										: html`<p>Inga alternativ hittades</p>`}
								</div>`
							: null}
					</div>
				</div>
			</div>
		`
	}

	renderPrice() {
		return html`
			<div
				class="filter-group"
				data-title="Pris"
				?data-open=${this._isOpen("Pris")}>
				<h3
					@click=${() => this._toggleAccordion("Pris")}
					aria-expanded=${this._isOpen("Pris") ? "true" : "false"}
					aria-controls="price-filter-content">
					Pris
					${when(
						this._isOpen("Pris"),
						() => html`${unsafeHTML(SVG_MINUS)}`,
						() => html`${unsafeHTML(SVG_PLUS)}`,
					)}
				</h3>
				<div class="content">
					<div class="price-values">
						<div class="from">
							<label> Från: </label>
							<span>${this.price_current_min}</span>
						</div>
						<div class="to">
							<label> Till: </label>
							<span>${this.price_current_max}</span>
						</div>
					</div>
					<div class="price-slider" id="price-slider"></div>
				</div>
			</div>
		`
	}

	renderBrands() {
		return html`
			<div
				class="filter-group"
				data-title="Märke"
				?data-open=${this._isOpen("Märke")}>
				<h3 @click=${() => this._toggleAccordion("Märke")}>
					Varumärke
					${when(
						this._isOpen("Märke"),
						() => html`${unsafeHTML(SVG_MINUS)}`,
						() => html`${unsafeHTML(SVG_PLUS)}`,
					)}
				</h3>
				<div class="content">
					<div
						class="select ${this.openSelect === "brands" ? "open" : ""}"
						@click=${() => this._toggleSelect("brands")}>
						<div class="select-display">
							<span>
								${this.selected_brand
									? this.selected_brand.name
									: "Välj varumärke"}
							</span>
							${this.selected_brand
								? html`<button
										aria-label="Ta bort filter för varumärke"
										@click=${() => {
											this.selected_brand = null
										}}>
										✕
									</button>`
								: html`<span>▾</span>`}
						</div>
						${this.openSelect === "brands"
							? html`
									<div class="select-options">
										${this.brands.map(
											brand => html`
												<div
													class="select-option ${this.selected_brand?.id ===
													brand.id
														? "selected"
														: ""}"
													@click=${e => {
														this._selectBrand(brand)
													}}>
													${brand.name}
												</div>
											`,
										)}
									</div>
								`
							: null}
					</div>
				</div>
			</div>
		`
	}

	renderAttribute(attr) {
		let findAttributeName = slug => {
			return attr.terms.find(t => t.slug === slug)?.name || ""
		}

		return html`
          <div class="filter-group" data-title="${
						attr.name
					}" ?data-open=${this._isOpen(attr.name)}>
            <h3 @click=${() => this._toggleAccordion(attr.name)}>${attr.name}
          ${when(
						this._isOpen(attr.name),
						() => html`${unsafeHTML(SVG_MINUS)}`,
						() => html`${unsafeHTML(SVG_PLUS)}`,
					)}

            </h3>
            <div class="content">
              <div class="select ${
								this.openSelect === `attr-${attr.id}` ? "open" : ""
							}" @click=${() => this._toggleSelect(`attr-${attr.id}`)}
              aria-expanded=${
								this.openSelect === `attr-${attr.id}` ? "true" : "false"
							}
              aria-controls="attribute-${attr.id}-options"
              >
              <div class="select-display">
                <span>
                  ${
										this.selected_attributes[attr.taxonomy]
											? `${findAttributeName(
													this.selected_attributes[attr.taxonomy],
												)}`
											: `Välj ${attr.name.toLowerCase()}`
									}
                </span>
                ${
									this.selected_attributes[attr.taxonomy]
										? html`<button
												aria-label="Ta bort filter för ${attr.name}"
												@click=${() => this._removeAttribute(attr.taxonomy)}>
												✕
											</button>`
										: html`<span>▾</span>`
								}
                
              </div>
              ${
								this.openSelect === `attr-${attr.id}`
									? html` <div class="select-options">
											${attr.terms && attr.terms.length > 0
												? attr.terms.map(
														term => html`
															<div
																class="select-option ${this.selected_attributes[
																	attr.taxonomy
																] &&
																this.selected_attributes[attr.taxonomy] ===
																	term.slug
																	? "selected"
																	: ""}"
																@click=${e => {
																	this._toggleAttribute(attr.taxonomy, term)
																}}>
																${term.name}
															</div>
														`,
													)
												: html`<p>Inga alternativ hittades</p>`}
										</div>`
									: null
							}

            </div>
          </div>
            </div>
          </div>
        `
	}
}
